import { atom } from 'jotai';
import Parse from 'parse';

export const _authProfile = atom<Parse.User | undefined | null>(null);
